import "./App.css";
import { Route, Routes } from "react-router-dom";
import {
  DtsAppContextProvider,
  useDtsAppContext,
} from "./components/provider/DtsAppContextProvider";
import { HowToFix } from "./components/pages/HowToFix";
import { Top } from "./components/pages/Top";
import { SelectPhenomenon } from "./components/pages/SelectPhenomenon";
import { SelectOccurrenceTiming } from "./components/pages/SelectOccurrenceTiming";
import { FeedBack } from "./components/pages/FeedBack";
import {
  PAGE_NAME_DISCLAIMER,
  PAGE_NAME_ENGINE_LABEL_LOCATION,
  PAGE_NAME_FAVORITE,
  PAGE_NAME_FEEDBACK,
  PAGE_NAME_HOW_TO_FIX,
  PAGE_NAME_INFERENCE_FACTOR_ITEM,
  PAGE_NAME_LOGIN,
  PAGE_NAME_SEARCH_HISTORY,
  PAGE_NAME_SELECT_MODEL,
  PAGE_NAME_SELECT_OCCURRENCE_TIMING,
  PAGE_NAME_SELECT_PHENOMENON,
  PAGE_NAME_TOP,
} from "./constants/common_constants";
import { SelectModel } from "./components/pages/SelectModel";
import { InferenceFactorItem } from "./components/pages/InferenceFactorItem";
import { EngineLabelLocation } from "./components/pages/EngineLabelLocation";
import { SearchHistory } from "./components/pages/SearchHistory";
import { Loading } from "../src/components/common/Loading";
import { ErrorDialog } from "../src/components/common/ErrorDialog";
import { useErrorDialog } from "./hooks";
import { Disclaimer } from "./components/pages/Disclaimer";
import { Favorite } from "./components/pages/Favorite";
import { SplashScreen } from "./components/common/SplashScreen";
import { LoginSaml } from "./components/pages/LoginSaml";

function App() {
  return (
    <DtsAppContextProvider>
      <AppContent />
    </DtsAppContextProvider>
  );
}

const AppContent = () => {
  // ユーザーID
  const userId =
    localStorage.getItem(
      `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
    ) || "";
  // エラー情報・ローディング表示（Contextから取得）
  const { loading, errorState, splash } = useDtsAppContext();
  const { closeErrorDialog } = useErrorDialog();

  return (
    <div className="App">
      <Routes>
        {userId ? (
          <>
            {/* サインイン済みの場合 */}
            <Route path={`/${PAGE_NAME_LOGIN}`} element={<LoginSaml />} />
            <Route path={`/${PAGE_NAME_DISCLAIMER}`} element={<Disclaimer />} />
            <Route path={`/${PAGE_NAME_TOP}`} element={<Top />} />
            <Route
              path={`/${PAGE_NAME_SELECT_MODEL}`}
              element={<SelectModel />}
            />
            <Route
              path={`/${PAGE_NAME_SELECT_OCCURRENCE_TIMING}`}
              element={<SelectOccurrenceTiming />}
              />
            <Route
              path={`/${PAGE_NAME_SELECT_PHENOMENON}`}
              element={<SelectPhenomenon />}
            />
            <Route
              path={`/${PAGE_NAME_INFERENCE_FACTOR_ITEM}`}
              element={<InferenceFactorItem />}
            />
            <Route path={`/${PAGE_NAME_FEEDBACK}`} element={<FeedBack />} />
            <Route
              path={`/${PAGE_NAME_HOW_TO_FIX}/:keyId?`}
              element={<HowToFix />}
            />
            <Route
              path={`/${PAGE_NAME_ENGINE_LABEL_LOCATION}`}
              element={<EngineLabelLocation />}
            />
            <Route
              path={`/${PAGE_NAME_SEARCH_HISTORY}`}
              element={<SearchHistory />}
            />
            <Route path={`/${PAGE_NAME_FAVORITE}`} element={<Favorite />} />
          </>
        ) : (
          <>
            {/* 未サインインの場合(ログイン画面が表示される) */}
            {/* ログイン */}
            <Route path={`/${PAGE_NAME_LOGIN}`} element={<LoginSaml />} />
            <Route path={`/${PAGE_NAME_DISCLAIMER}`} element={<LoginSaml />} />
            <Route path={`/${PAGE_NAME_TOP}`} element={<LoginSaml />} />
            <Route
              path={`/${PAGE_NAME_SELECT_MODEL}`}
              element={<LoginSaml />}
            />
            <Route
              path={`/${PAGE_NAME_SELECT_PHENOMENON}`}
              element={<LoginSaml />}
            />
            <Route
              path={`/${PAGE_NAME_INFERENCE_FACTOR_ITEM}`}
              element={<LoginSaml />}
            />
            <Route path={`/${PAGE_NAME_FEEDBACK}`} element={<LoginSaml />} />
            <Route
              path={`/${PAGE_NAME_HOW_TO_FIX}/:keyId?`}
              element={<LoginSaml />}
            />
            <Route
              path={`/${PAGE_NAME_ENGINE_LABEL_LOCATION}`}
              element={<LoginSaml />}
            />
            <Route
              path={`/${PAGE_NAME_SEARCH_HISTORY}`}
              element={<LoginSaml />}
            />
            <Route path={`/${PAGE_NAME_FAVORITE}`} element={<LoginSaml />} />
          </>
        )}
      </Routes>
      {/* ローディング */}
      {loading && <Loading />}
      {/* スプラッシュ画面 */}
      {splash && <SplashScreen />}
      {/* エラーダイアログ */}
      {errorState.isShowErrorDialog && (
        <ErrorDialog
          title={errorState.errorTitle}
          message={errorState.errorMessage}
          onOk={() => closeErrorDialog()}
        />
      )}
    </div>
  );
};

export default App;
